import TransactionService from '@/services/atp-transactions'
import Utils from '@/utils/utils'
import * as types from '../mutations'

const state = {
  transactions: [],
  productTransactions: [],
  isLoadingTransactions: false,
  totalTransactions: 0,
  totalProductTransactions: 0
}

const getters = {
  transactions: (state) => state.transactions,
  productTransactions: (state) => state.productTransactions,
  isLoadingTransactions: (state) => state.isLoadingTransactions,
  totalTransactions: (state) => state.totalTransactions,
  totalProductTransactions: (state) => state.totalProductTransactions
}

const actions = {
  async loadTransactions ({ commit }, payload) {
    const data = await TransactionService.loadTransactions(payload)
    const transactions = data?.results || []
    const count = data?.count || 0

    commit(types.SET_TRANSACTIONS, transactions)
    commit(types.SET_TRANSACTIONS_COUNT, count)
  },

  setIsLoadingTransactions ({ commit }, isLoading) {
    commit(types.SET_IS_LOADING_TRANSACTIONS, isLoading)
  },

  setTransactions ({ commit }, transactions) {
    commit(types.SET_TRANSACTIONS, transactions)
  },

  setProductTransactions ({ commit }, payload) {
    commit(types.SET_PRODUCT_TRANSACTIONS, payload)
  },

  async loadProductTransactions ({ commit, rootState }, payload) {
    const productData = await TransactionService.loadTransactions(payload)
    const productTransactions = productData?.results || []

    const payloadTransfer = {
      productTransactions,
      selectedProduct: rootState.atpProducts.selectedProduct
    }
    commit(types.SET_TOTAL_PRODUCTS_TRANSACTIONS_COUNT, productData.count)
    commit(types.SET_PRODUCT_TRANSACTIONS, payloadTransfer)
  },

  setTotalProductsTransactionsCount ({ commit }, count) {
    commit(types.SET_TOTAL_PRODUCTS_TRANSACTIONS_COUNT, count)
  }
}

const mutations = {
  [types.SET_TRANSACTIONS] (state, transactions) {
    if (transactions.length > 0) {
      state.transactions = transactions.map((transaction) => {
        return {
          ...transaction,
          product_name: transaction?.product_registration?.product_name,
          created_at: Utils.formatDate(transaction.created_at, false, true),
          sku: transaction?.product_registration?.product_sku
        }
      })
    } else {
      state.transactions = transactions
    }
  },

  [types.SET_IS_LOADING_TRANSACTIONS] (state, isLoading) {
    state.isLoadingTransactions = isLoading
  },

  [types.SET_TRANSACTIONS_COUNT] (state, count) {
    state.totalTransactions = count
  },

  [types.SET_TOTAL_PRODUCTS_TRANSACTIONS_COUNT] (state, productTransactionsCount) {
    state.totalProductTransactions = productTransactionsCount
  },

  [types.SET_PRODUCT_TRANSACTIONS] (state, payload) {
    const { productTransactions, selectedProduct = null } = payload
    if (productTransactions.length > 0) {
      const transformedProducts = productTransactions.map((productTransaction) => {
        return {
          ...productTransaction,
          product_name: productTransaction?.product_registration?.product_name,
          created_at: Utils.formatDate(productTransaction?.created_at, false, true),
          sku: productTransaction?.product_registration?.product_sku
        }
      }).filter((productTrans) => productTrans?.product_registration?.id === selectedProduct?.id)

      state.productTransactions = transformedProducts
    } else {
      state.productTransactions = productTransactions
    }
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
